var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useQuery } from '@tanstack/react-query';
import useFetch from './use-fetch';
function useServiceFileQuery(_a) {
    var config = _a.config, _b = _a.path, path = _b === void 0 ? '' : _b, _c = _a.queryOptions, queryOptions = _c === void 0 ? { retry: false } : _c;
    var fetchWrapper = useFetch(config);
    return useQuery(__assign({ queryKey: [config.hosts.serviceFile], queryFn: function () {
            return fetchWrapper(path, { method: 'GET' }, config.hosts.serviceFile, false);
        } }, queryOptions));
}
export default useServiceFileQuery;
//# sourceMappingURL=use-service-file.js.map